import { useState } from 'react';
import { useApp } from '../lib/app-context';
import { Banner, TextField } from '../components/ui';

export function SignIn() {
    const { data, setUser } = useApp();
    const [email, setEmail] = useState('admin@strengthpool.fit');
    const [password, setPassword] = useState('');
    const [error, setError] = useState<string | null>(null);
    const [busy, setBusy] = useState(false);

    const isMock = data.label.startsWith('Mock');

    async function submit(event: React.FormEvent) {
        event.preventDefault();
        setBusy(true);
        setError(null);
        try {
            setUser(await data.signIn(email, password));
        } catch (e) {
            setError(e instanceof Error ? e.message : String(e));
        } finally {
            setBusy(false);
        }
    }

    return (
        <div className="signin">
            <form className="card stack" onSubmit={submit}>
                <div className="row">
                    <div className="brand-mark">▽</div>
                    <div>
                        <h2>Strength Pool Admin</h2>
                        <p className="small muted">Sign in to manage module content</p>
                    </div>
                </div>

                {error && <Banner tone="error" title="Could not sign in" items={[error]} />}

                <TextField label="Email" value={email} onChange={setEmail} />
                {!isMock && (
                    <div className="field">
                        <label>Password</label>
                        <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
                    </div>
                )}

                <button className="btn" disabled={busy} type="submit">
                    {busy ? 'Signing in…' : 'Sign in'}
                </button>

                {isMock && (
                    <div className="banner">
                        <strong>Running on mock data</strong>
                        <p className="small" style={{ marginTop: 6 }}>
                            No backend configured, so no password is needed. Sign in as{' '}
                            <code className="mono">admin@strengthpool.fit</code> for the super-admin
                            view, or <code className="mono">owner@macebell.fit</code> to see what a
                            module owner sees.
                        </p>
                    </div>
                )}
            </form>
        </div>
    );
}
